import api from '../axios';

export const GET_ALL_EXHIBITORS = 'GET_ALL_EXHIBITORS'
export const SET_ALL_EXHIBITORS = 'SET_ALL_EXHIBITORS'

export const getAllExhibitors = (token) => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + token,
        },
    };
    return api.get('/exhibitors' + '?size=300', options)
        .then((response) => {
            dispatch({ type: GET_ALL_EXHIBITORS, payload: response.data })
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const setAllExhibitors = (payload) => (dispatch) => {
    dispatch({ type: SET_ALL_EXHIBITORS, payload })
}

export const scanExhibitor = (payload, link, token) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + token,
        }
    }
    return api.post(`/scans/${link}`, payload, apiHeader)
        .then(response => {
            // dispatch({ type: ADD_PARTICIPANT, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response)
        })
}